
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.075 9.742l-3.333 3.333a.833.833 0 000 1.183.833.833 0 001.183 0l3.333-3.333a.837.837 0 10-1.183-1.183z"}}),_c('path',{attrs:{"d":"M12.234 16.5l-1.067 1.058a3.5 3.5 0 01-4.65.334 3.333 3.333 0 01-.225-4.942l1.183-1.192a.832.832 0 000-1.183.833.833 0 00-1.183 0l-1.058 1.067a5.125 5.125 0 00-.559 6.725 5.05 5.05 0 007.559.5l1.183-1.184a.836.836 0 10-1.183-1.183zM18.383 4.683a5.15 5.15 0 00-6.775.567l-.9.917a.908.908 0 00-.142 1.341.834.834 0 001.184 0l1.083-1.091a3.475 3.475 0 014.642-.334 3.333 3.333 0 01.225 4.959l-1.183 1.191a.834.834 0 00.27 1.366.834.834 0 00.913-.182l1.183-1.184a5.049 5.049 0 00-.5-7.55z"}})])
          )
        }
      }
    